module.exports = __webpack_public_path__ + "static/logo3-ad0f29f9c685ba4998d1d08a90d5e040.svg";